import React from 'react';
import type { BapAd } from '../../../types';
import {
    SearchAdSecondaryLabel,
    SecondaryLabelRenderProps,
} from '../SearchAdSecondaryLabel';

const sortedLabelIds = ['seller_pays_shipping'];

type BapSecondaryLabelProps = {
    ad: BapAd;
    className?: string;
    secondaryLabel?: (
        props: SecondaryLabelRenderProps,
    ) => React.ReactElement | null;
};

export function BapSecondaryLabel(props: BapSecondaryLabelProps) {
    const { ad, className, secondaryLabel } = props;

    return (
        <SearchAdSecondaryLabel
            ad={ad}
            className={className}
            labelIds={sortedLabelIds}
            render={secondaryLabel ?? renderBapSecondaryLabel}
        />
    );
}

function renderBapSecondaryLabel({
    className = '',
    label,
}: SecondaryLabelRenderProps) {
    if (!label) {
        return null;
    }

    return (
        <>
            {label.id === 'seller_pays_shipping' && (
                <span
                    className={`${className} s-text-positive font-bold text-xs`}
                >
                    {label.text}
                </span>
            )}
        </>
    );
}
